module.exports = __webpack_public_path__ + "media/images/font/SofiaProLight-df4aad45fc38e1fadf2712e3d6759c73.eot";